<div [class]="getClassName()">
  <cms-new *ngFor='let new of list' [rssNew]="new" [postLink]='postlink'></cms-new>
</div>
